import React, { FC } from 'react'
import { NumberInputViewModel } from '@sitecore-jss/sitecore-jss-forms'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'

import BaseTextField from '../baseTextField'

const NumberField: FC<ValueFieldProps<NumberInputViewModel>> = (props) => (
  <BaseTextField type="number" {...props} />
)

export default NumberField
